import { NodeViewContent, NodeViewWrapper } from "@tiptap/react";

export default ({ props, children, Icon, text }: any) => {
  return (
    <NodeViewWrapper
      className="react-component"
      onClick={() => {
        props.editor.commands.setNodeSelection(props.getPos());
      }}
    >
      <NodeViewContent contentEditable="false" className="socialMediaContainer">
        {props?.node.type.spec.draggable ? (
          <div draggable="true" data-drag-handle="" style={{ width: "100%" }}>
            {!(props?.node?.attrs?.url ?? props?.node?.attrs?.src) ? (
              <div
                className="w-full bg-zinc-100 py-8 px-6 flex items-center justify-center gap-2 socialMediaCard"
                draggable="true"
                data-drag-handle=""
              >
                <Icon size={24} />
                <p
                  className="w-full flex items-center justify-start mt-0"
                  style={{
                    marginTop: 0,
                  }}
                >
                  {text}
                </p>
              </div>
            ) : (
              <div
                style={{ display: "flex", justifyContent: "center" }}
                draggable="true"
                data-drag-handle=""
              >
                {children}
              </div>
            )}
          </div>
        ) : null}
      </NodeViewContent>
    </NodeViewWrapper>
  );
};
